import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { from, Observable, of } from 'rxjs';
import { catchError, skip } from 'rxjs/operators';

export class ModalRef {
  public get result(): Observable<unknown> {
    return from(this.ngbModalRef.result);
  }

  public get onDismiss(): Observable<unknown> {
    return from(this.ngbModalRef.result).pipe(
      /**
       * On dismiss promise is rejected, so we cary only about errors
       */
      skip(Infinity),
      catchError(() => of(undefined)),
    );
  }

  public get componentInstance() {
    return this.ngbModalRef.componentInstance;
  }

  constructor(private ngbModalRef: NgbModalRef) {}

  public close(result?: unknown) {
    this.ngbModalRef.close(result);
  }

  public dismiss(reason?: unknown) {
    this.ngbModalRef.dismiss(reason);
  }
}
